import { Box, Button, Center, Flex, HStack, IconButton, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spacer, Table, TableContainer, Tbody, Td, Th, Thead, Tooltip, Tr, useDisclosure } from '@chakra-ui/react'
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTable, useGlobalFilter } from 'react-table';
import * as locales from 'react-date-range/dist/locale';
import { useEffect, useMemo, useState } from 'react'; 
import { DateRangePicker } from 'react-date-range';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';

// Icons
import { BsCalendar3, BsSendArrowUp } from "react-icons/bs";
import { IoCalendarOutline } from "react-icons/io5";
import { RiHistoryLine } from "react-icons/ri";
import { WiDayCloudy } from "react-icons/wi";
import { FiDownload } from "react-icons/fi";

// Components
import { postData, getData, updateData, postDataGenesys } from '../../Services/api';
import ExportDataRange from '../../Components/Export/ExportDataRange';
import AdminNavbar from '../../Components/Navbar/AdminNavbar';

// Styles
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import './styleRange.css';

const Dashboard = () => {

    const [dateInitial, setDateInitial] = useState([{startDate: new Date(),endDate: new Date(),key: 'selection',}]);
    const [loadingButton, setLoadingButton] = useState(false);
    const [updatePage, setUpdatePage] = useState(false);
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [countLeads, setcountLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const navigate = useNavigate();

    const { executeRecaptcha } = useGoogleReCaptcha();

    const login = localStorage.getItem('login');

    useEffect(() => {
        if (login) {
            const extractCountLeads = async() => {
                const counts = await getData('allLeads');
                setcountLeads(counts?.data);
            }
    
            const extractLeads = async() => {
                const leads = await getData('leadsToday');
                setData(leads?.data?.DATA);
            }

            setLoading(false);
            extractCountLeads();
            extractLeads();
        } else {
            navigate('/Login');
        }
    }, [updatePage]);
    
    const columns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Nombre Completo',
                accessor: 'name',
            },
            {
                Header: 'Telefono',
                accessor: 'number',
            },
            {
                Header: 'Segmento',
                accessor: 'segmento',
            },
            {
                Header: 'Estrategia',
                accessor: 'estrategia',
            },
            {
                Header: 'Origen',
                accessor: 'origen',
            },
            {
                Header: 'Tipo de Formulario',
                accessor: 'plan',
            },
            // {
            //     Header: 'Id lead',
            //     accessor: 'id_lead',
            // },
            {
                Header: 'Gclid',
                accessor: 'gclid',
            },
            {
                Header: 'Grupo de anuncio',
                accessor: 'anuncioGroup',
            },
            {
                Header: 'Campaignid',
                accessor: 'campaignid',
            },
            {
                Header: 'Adgroupid',
                accessor: 'adgroupid',
            },
            {
                Header: 'Keyword',
                accessor: 'keyword',
            },
            {
                Header: 'AdId',
                accessor: 'adId',
            },
            {
                Header: 'Fecha Creación',
                accessor: 'fecha',
            },
            {
                Header: 'Respuesta Genesys',
                accessor: 'insertGenesys',
            },
            {
                Header: 'Acepta Comunicación',
                accessor: 'acceptedComunicacion',
            },
            {
                Header: 'Acepta TYT',
                accessor: 'acceptedtyt',
            },
        ],
        []
    );

    const keywords = ['error', 'Primera inserción', 'score', '{}'];

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setGlobalFilter,
        state: { globalFilter }
    } = useTable({ columns, data }, useGlobalFilter);

    const formatDate = (current_datetime) => {
        let formatted_date = current_datetime.getFullYear() + "-"  
            + ( (current_datetime.getMonth() < 9 ? '0': '') + (current_datetime.getMonth() + 1)) + "-" 
            + ( (current_datetime.getDate() < 9 ? '0': '') + (current_datetime.getDate()) ) 
        return formatted_date;
    }

    const handleExport = async() => {
        const dateStartTime = formatDate(dateInitial[0].startDate);
        const dateEndTime = formatDate(dateInitial[0].endDate);

        try {
            const ExtractGrupsForDate = await postData('filter', {
                fechaInicio: dateStartTime,
                fechaFin: dateEndTime
            });

            if (ExtractGrupsForDate?.OK === true) {
                setData(ExtractGrupsForDate.DATA);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: `Ocurrio un error al traer la data!`
                })
            }
    
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Ocurrio un error! - ${error}`
            });
        }
        onClose();
    }

    const handleDownloadData = () => {
        ExportDataRange({apiData: data, fileName:`Export Leads Entel` });
    }

    const extractSales = async(endPoint) => {
        const extract = await getData(endPoint);
        ExportDataRange({apiData: extract?.data?.DATA, fileName:`Export Leads Entel` })
    }

    const insertRetry = async(data) => {
        setLoadingButton(true);
        if (!executeRecaptcha) {
            alert("Error: No se pudo cargar reCAPTCHA.");
            return;
        }

        const newToken = await executeRecaptcha("submit_form");
            
        if (!newToken) {
            alert("Error al validar reCAPTCHA. Intenta nuevamente.");
            return false;
        };

        let endpointSave = data?.segmento === "Movil" ? 'save' : 'saveFibra';

        const submitGenesys = await postDataGenesys({
            consulta: {
                origen: 'publico',
                tipo: endpointSave === 'saveFibra' ? 'hogar' : 'movil',
                msisdn: `56${data?.number}`,
                identification: '',
                firstName: data?.name,
                lastName: '',
                eMailAddress: "",
                socialMediaName: 'edealer',
                socialMediaSite: endpointSave === 'saveFibra' ? '10260054' : "10310024",
                mktCampId: endpointSave === 'saveFibra' ? 'becall-hogar' : 'becall-movil',
                mktOfferName: `${data?.plan}`
            },
            url: `${data?.origen}`
        }, newToken);

        let responseGenesys = JSON.stringify(submitGenesys);

        await updateData('updateRequestGenesys', {
            phone: data?.number,
            insertGenesys: responseGenesys,
        });
    
        Swal.fire({
            icon: 'info',
            title: responseGenesys,
            timerProgressBar: true,
            timer: 5000,
            showConfirmButton: false
        })

        setLoadingButton(false);
        setUpdatePage(!updatePage);
    };


    return (
        <>
            {
                !loading
                    &&
                        <>
                            {/* Navbar */}
                            <AdminNavbar /> 

                            {/* Targets */}
                            <Flex w="80%" m="auto" my="10" flexDirection={{base: "column", sm: "column", md: "column", lg: "row"}}>
                                <Box bg="#002EFF" borderRadius='20' py="5" px="8">
                                    <HStack spacing='10px'>
                                        <RiHistoryLine size="30px" color="white" />
                                        <Button onClick={() => extractSales('leadsHistory')} className="Title" color="white" variant="link" fontSize="2xl">HISTORICO: {countLeads?.History}</Button>
                                    </HStack>
                                </Box>
                                <Spacer />
                                <Box bg="#002EFF" borderRadius='20' py="5" px="8" mt={{base: "5", md: "0"}}>
                                    <HStack spacing='10px'>
                                        <BsCalendar3 size="30px" color="white" />
                                        <Button onClick={() => extractSales('leadsMonth')} className="Title" color="white" variant="link" fontSize="2xl">MES: {countLeads?.Mes}</Button>
                                    </HStack>
                                </Box>
                                <Spacer />
                                <Box bg="#002EFF" borderRadius='20' py="5" px="8" mt={{base: "5", md: "0"}}>
                                    <HStack spacing='10px'>
                                        <WiDayCloudy size="30px" color="white" />
                                        <Button onClick={() => extractSales('leadsToday')} className="Title" color="white" variant="link" fontSize="2xl">DÍA: {countLeads?.Dia}</Button>
                                    </HStack>
                                </Box>
                            </Flex>

                            {/* Table */}
                            <Box my="10" mx="auto" w="80%">
                                <Flex>
                                    <Tooltip hasArrow label='Filtrar por fecha'>
                                        <Button onClick={onOpen} mr="5">
                                            <IoCalendarOutline />
                                        </Button>
                                    </Tooltip>

                                    <Tooltip hasArrow label='Descargar'>
                                        <Button onClick={handleDownloadData}>
                                            <FiDownload />
                                        </Button>
                                    </Tooltip>
                                </Flex>

                                <TableContainer {...getTableProps()} mt="6">
                                    <Table size='sm'>
                                        <Thead> 
                                            {
                                                headerGroups.map(headerGroup => (
                                                    <Tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                        <Th>
                                                            Insert Genesys
                                                        </Th>
                                                        {
                                                            headerGroup.headers.map(column => (
                                                                <Th style={{width: "150px", maxWidth: '150px'}} {...column.getHeaderProps()} key={column.id}>
                                                                    {
                                                                        column.render('Header')
                                                                    }
                                                                </Th>
                                                            ))
                                                        }
                                                    </Tr>
                                                ))
                                            }
                                        </Thead>
                                        <Tbody {...getTableBodyProps()}>
                                            {
                                                rows.map(row => {
                                                    prepareRow(row)
                                                    return (
                                                        <Tr {...row.getRowProps()} key={row.id}>
                                                            <Td>
                                                                {keywords.some(word => row.values.insertGenesys.includes(word)) && <Tooltip hasArrow label="Insertar">
                                                                    <IconButton icon={<BsSendArrowUp />} isLoading={loadingButton} bg='#FD3D00' color='white' border='2px solid #FD3D00' _hover={{color: '#FD3D00', bg: 'transparent'}} onClick={() => insertRetry(row.values)} />
                                                                </Tooltip>}
                                                            </Td>
                                                            {
                                                                row.cells.map((cell, i) => {
                                                                    return (
                                                                        <Td style={{maxWidth: '300px'}} whiteSpace="normal" overflow='hidden' textOverflow='ellipsis' {...cell.getCellProps()} key={i}>
                                                                            {
                                                                                cell.render('Cell')
                                                                            }
                                                                        </Td>
                                                                    )
                                                                })
                                                            }
                                                        </Tr>
                                                    )
                                                })
                                            }
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            </Box>

                            {/* Modal filter Leads */}
                            <Modal
                                isCentered
                                onClose={onClose}
                                isOpen={isOpen}
                                motionPreset='slideInBottom'
                                size={'xl'}
                            >
                                <ModalOverlay />

                                <ModalContent>
                                    <ModalHeader><Center>FILTRAR POR RANGO DE FECHAS</Center></ModalHeader>
                                    
                                    <ModalCloseButton />

                                    <ModalBody>
                                        <DateRangePicker
                                            className="range-date"
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            ranges={dateInitial}
                                            onChange={item => setDateInitial([item.selection])}
                                            locale={locales['es']}
                                        />
                                    </ModalBody>

                                    <ModalFooter>
                                        <Button colorScheme='blue' variant='outline' mr={3} onClick={onClose}>
                                            Cancelar
                                        </Button>
                                        <Button leftIcon={<FiDownload />} colorScheme='green' variant='outline' onClick={handleExport}>FILTRAR</Button>
                                    </ModalFooter>
                                </ModalContent>
                            </Modal>
                        </>
            }
        </>
    )
};

export default Dashboard;